import {
  axios,
  fetcher,
  mutateInternal,
  apiRequest,
  configureAxiosBaseUrl,
  configureAuthorizationHeader,
  clearAuthorizationHeader,
} from './client';

import { isBrowser } from './platform';

export {
  axios,
  fetcher,
  mutateInternal,
  apiRequest,
  configureAxiosBaseUrl,
  configureAuthorizationHeader,
  clearAuthorizationHeader,
};

export { isBrowser };
